import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary" }, "Reverter aprovação", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-neutral50"
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col gap-4 text-left"
}
const _hoisted_6 = {
  class: "flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl p-4",
  "data-testid": "check-validation-reverse-alert"
}
const _hoisted_7 = {
  class: "w-5 h-5 text-amber-600 shrink-0 mt-0.5",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-amber-800" }, [
  /*#__PURE__*/_createTextVNode(" Reverter devolve o registro para "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Em análise"),
  /*#__PURE__*/_createTextVNode(" e ele deixa de valer como presença até uma nova decisão. ")
], -1)
const _hoisted_10 = { class: "flex flex-col gap-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm font-bold text-textPrimary",
  for: "check-validation-reverse-justification"
}, [
  /*#__PURE__*/_createTextVNode(" Justificativa da reversão "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-negative" }, "*")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50" }, " Obrigatória, com no mínimo 20 caracteres. Fica registrada no histórico do registro. ", -1)
const _hoisted_13 = { class: "flex gap-4 w-full" }
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = { class: "flex-1" }

import { computed, ref, watch } from 'vue'

import { mdiAlertCircleOutline } from '@mdi/js'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import PolarButton from '@/components/designSystem/Buttons/PolarButton/index.vue'

import type { CheckValidationRow } from '../types'

export interface ReverseCheckPayload {
  checkId: number
  version: number
  justification: string
}

const MIN_JUSTIFICATION_LENGTH = 20


export default /*#__PURE__*/_defineComponent({
  __name: 'ReverseCheckModal',
  props: {
    modelValue: { type: Boolean },
    row: {},
    saving: { type: Boolean }
  },
  emits: ["update:modelValue", "reverse"],
  setup(__props: any, { emit }) {

const props = __props;





const justification = ref('')

const trimmedLength = computed(() => justification.value.trim().length)
const isValid = computed(() => trimmedLength.value >= MIN_JUSTIFICATION_LENGTH)
const canSubmit = computed(() => isValid.value && !!props.row && !props.saving)

watch(
  () => [props.row?.checkId, props.modelValue],
  () => {
    justification.value = ''
  }
)

function submit() {
  if (!canSubmit.value || !props.row) return
  emit('reverse', {
    checkId: props.row.checkId,
    version: props.row.version,
    justification: justification.value.trim()
  })
}

function close() {
  if (props.saving) return
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[480px]",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.row)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
              _createTextVNode(" Registro "),
              _createElementVNode("span", _hoisted_4, "#" + _toDisplayString(_ctx.row.checkId), 1),
              (_ctx.row.doctor.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(_ctx.row.doctor.name), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.row.stationDate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" · plantão de " + _toDisplayString(_ctx.row.stationDate), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(OutlineButton, {
            text: "Cancelar",
            width: "100%",
            height: "48px",
            disabled: _ctx.saving,
            "data-testid": "check-validation-reverse-cancel-button",
            onClick: close
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(PolarButton, {
            "polar-variant": "outline",
            text: "Confirmar reversão",
            block: "",
            height: "48",
            disabled: !canSubmit.value,
            "data-testid": "check-validation-reverse-confirm-button",
            onClick: submit
          }, null, 8, ["disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.row)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                _createElementVNode("path", {
                  d: _unref(mdiAlertCircleOutline),
                  fill: "currentColor"
                }, null, 8, _hoisted_8)
              ])),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("textarea", {
                id: "check-validation-reverse-justification",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((justification).value = $event)),
                class: "w-full border border-gray-300 rounded-lg p-3 text-sm text-textPrimary resize-none focus:outline-none focus:ring-2 focus:ring-primary30",
                rows: "3",
                maxlength: "500",
                placeholder: "Descreva por que a aprovação está sendo desfeita",
                "data-testid": "check-validation-reverse-justification-input"
              }, null, 512), [
                [_vModelText, justification.value]
              ]),
              _hoisted_12,
              _createElementVNode("span", {
                class: _normalizeClass(["self-end text-xs whitespace-nowrap", isValid.value ? 'text-neutral50' : 'text-negative']),
                "data-testid": "check-validation-reverse-char-counter"
              }, _toDisplayString(trimmedLength.value) + "/" + _toDisplayString(MIN_JUSTIFICATION_LENGTH), 3)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})